<script setup lang="ts">
</script>

<template>
  <div class="break-wrapper hidden md:block">
    <hr class="w-full border-solid" />
  </div>
</template>